<div class="dialog-header gbg">
    <div class="dialog-title fs20">Calculation Summary</div>
    <button mat-icon-button (click)="close()" [tabIndex]="-1">
        <i class="fas fa-times fs20"></i>
    </button>
</div>
<form name="iForm" (ngSubmit)="onSubmit()" [formGroup]="iForm" #fv="ngForm">
    <div class="dialog-body">
        <div class="dpanel-content" style="padding-right: 15px;">
            <mat-form-field appearance="outline" class="wp100 bold">
                <mat-label>Subject</mat-label>
                <input matInput placeholder="Subject" formControlName="subject" required maxlength="50">
                <mat-error *ngIf="f.subject.errors?.required && f.subject.touched">Subject is <strong>required</strong></mat-error>
                <mat-hint align="end" aria-live="polite" *ngIf="f.subject.value.length > 0">
                    {{f.subject.value.length}} / 50
                </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" class="wp100 bold">
                <mat-label>Message</mat-label>
                <textarea matInput placeholder="Message" rows="10" formControlName="note" required maxlength="300"></textarea>
                <mat-error *ngIf="f.note.errors?.required && f.note.touched">Message is <strong>required</strong></mat-error>
                <mat-hint align="end" aria-live="polite" *ngIf="f.note.value.length > 0">
                    {{f.note.value.length}} / 300
                </mat-hint>
            </mat-form-field>
        </div>
        <ngx-loading [show]="iloading"></ngx-loading>
    </div>
    <div class="dialog-footer">
        <div class="row">
            <div class="col-6">
                <button mat-raised-button type="button" class="cpanel-btn c-white" (click)="close()" color="warn"><i class="fas fa-times"></i>&nbsp;Close</button>
            </div>
            <div class="col-6 text-right">
                <button mat-raised-button color="accent" class="cpanel-btn c-white bold" type="submit" [disabled]="!iForm.valid"> <i class="fas fa-paper-plane c-white fs16 ibtn"></i> Send </button>
            </div>
        </div>
    </div>
</form>